/**
 * Not-found route (simplified from web/src/routes/NotFoundRoute.tsx).
 *
 * A single, unauthenticated 404 surface. Signed-in operators get a way back
 * to the console; everyone else is pointed at sign-in.
 */
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Button } from '@/components/ui/button';

export function NotFoundRoute() {
  const { isSignedIn } = useAuth();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <p className="text-sm font-medium text-primary">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        The page you are looking for does not exist or may have moved.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button asChild>
          <Link to={isSignedIn ? '/' : '/sign-in'}>
            Go {isSignedIn ? 'to the admin console' : 'to sign in'}
          </Link>
        </Button>
      </div>
    </div>
  );
}
